// extracted by mini-css-extract-plugin
export default {"icon":"info-icon_icon__24bI1","label":"info-icon_label__b3p1s"};